import { API_URL, API_URL_INTEGRATION } from '@/common/config'

export const LOGIN_URL = `${API_URL}/login`
export const REFRESH_TOKEN_URL = `${API_URL}/refresh`
export const PLAYER_SIGN_UP_URL = `${API_URL}/player-sign-up/:token`
export const FETCH_SIGN_UP_DATA_URL = `${API_URL}/player-sign-up/:token`
export const SIGN_UP_EMAIL_CHECK_URL = `${API_URL}/player-sign-up/email-check/:token`
export const RESEND_EMAIL_CONFIRMATION_URL = `${API_URL}/account/email-confirmation`
export const EMAIL_CONFIRMATION_URL = `${API_URL}/player-sign-up/email-confirm/:token`
export const PASSWORD_RESET_URL = `${API_URL}/password_reset`
export const CHECK_PASSWORD_RESET_TOKEN = `${API_URL}/password_reset/:token`
export const CHANGE_PASSWORD_URL = `${API_URL}/web/account/`
export const CHANGE_PASSWORD_PROFILE_URL = `${API_URL}/web/account/:accountId/password`
export const RESET_PASSWORD_URL = `${API_URL}/password_reset/:token`
export const EDIT_PROFILE_URL = `${API_URL}/web/players/:accountId`
export const CHILD_CONFIRMATION_URL = `${API_URL}/player-sign-up/child-confirmation/:token`
export const UNSUBSCRIBE_EMAIL_URL = `${API_URL}/web/subscriptions/:subscriptionId`
export const FETCH_PROFILE_URL = `${API_URL}/web/account/:accountId`
export const UNSUBSCRIBE_EMAIL_URL_BY_TOKEN = `${API_URL}/subscriptions/:token`
export const CHANGE_EMAIL_URL = `${API_URL}/web/account/:accountId/email-change`
export const EMAIL_CHANGE_CONFIRMATION_URL = `${API_URL}/email-change-confirmation/:token`
export const UPDATE_PRIVACY_SETTINGS_URL = `${API_URL}/web/player/:playerId/privacy/activity/:privacyBoolean`
export const ORGANIZATION_INVITE_URL = `${API_URL}/player-sign-up/organization-invite/:token`
export const UPDATE_LANGUAGE_URL = `${API_URL}/web/account/:accountId/language`
export const UPDATE_UNITS_URL = `${API_URL}/web/player/:id/unit-preference`
export const INTEGRATIONS_URL = `${API_URL_INTEGRATION}/integration/user/authentication`
export const INTEGRATIONS_CHILD_URL = `${API_URL_INTEGRATION}/integration/user/authentication/child`
export const SYSTEM_WIDE_ACTIVITY_PRIVACY_URL = `${API_URL}/web/player/:playerId/system-wide-privacy/activity/:privacyBoolean`

// CALENDAR
export const FETCH_CALENDAR_DATA_URL = `${API_URL}/web/player-activities/calendar/:playerId`

//CALENDAR ACTIVITIES
export const FETCH_CALENDAR_ACTIVITY_DATA_URL = `${API_URL}/web/player-activities/:activityId`
export const DELETE_ACTIVITY_SESSION_URL = `${API_URL}/web/player-activities/:activityId`
export const CHANGE_ACTIVITY_DESCRIPTION_URL = `${API_URL}/web/player-activities/:activityId/description`
export const GET_ACTIVITY_SEGMENTS_URL = `${API_URL}/web/player-activities/:activityId/segments`
export const CREATE_ACTIVITY_SEGMENTS_URL = `${API_URL}/web/player-activities/:activityId/segments?metricsType=:metricsType`
export const DELETE_ACTIVITY_SEGMENTS_URL = `${API_URL}/web/player-activities/:activityId/segments/:segmentId`
export const GET_SEGMENTS_STATS_TABLE_URL = `${API_URL}/web/player-activities/:activityId/segments`
export const GET_MORE_PRECISE_ACTIVITY_DATA_URL = `${API_URL}/web/player-activities/:activityId`
export const GET_TIMELINE_CHART_DATA_URL = `${API_URL}/web/dashboard/timeline/players/:playerId/individual`

//SESSION HISTORY
export const FETCH_SESSION_HISTORY_DATA_URL = `${API_URL}/web/session-history/:playerId`

// DASHBOARD
export const FETCH_TIMELINE_FOR_TEAM_URL = `${API_URL}/web/dashboard/timeline/players/:playerId/teams/:teamId`
export const FETCH_DASHBOARD_URL = `${API_URL}/web/dashboard/players/:playerId`
export const FETCH_TIMELINE_FOR_ALL_TEAMS_URL = `${API_URL}/web/dashboard/timeline/players/:playerId/all-teams`
export const FETCH_TIMELINE_FOR_INDIVIDUAL_URL = `${API_URL}/web/dashboard/timeline/players/:playerId/individual`
export const FETCH_DASHBOARD_FOR_TEAM_URL = `${API_URL}/web/dashboard/players/:playerId/teams/:teamId`
export const FETCH_DASHBOARD_FOR_ALL_TEAMS_URL = `${API_URL}/web/dashboard/players/:playerId/all-teams`
export const FETCH_DASHBOARD_FOR_INDIVIDUAL_ACTIVITIES_URL = `${API_URL}/web/dashboard/players/:playerId/individual`

// TEAMS
export const FETCH_PLAYER_TEAMS_URL = `${API_URL}/web/players/:playerId/teams`

// ADDITIONAL EMAIL
export const ADD_ADDITIONAL_EMAIL_URL = `${API_URL}/web/player/:playerId/additional-email`
export const DELETE_ADDITIONAL_EMAIL_URL = `${API_URL}/web/player/:playerId/additional-email/:emailId`
export const RESEND_ADDITIONAL_EMAIL_URL = `${API_URL}/web/player/:playerId/additional-email-resend-confirmation/:emailId`
export const CONFIRM_ADDITIONAL_EMAIL_URL = `${API_URL}/player-additional-email/email-confirm/:token`

// SHARE ACTIVITY
export const FETCH_SHARE_DATA_URL = `${API_URL}/shared/activity/:activityId`

// LEADERBOARD
export const FETCH_LEADERBOARD_DATA_URL = `${API_URL}/common/leaderboard`
export const FETCH_LEADERBOARD_TEAMS_URL = `${API_URL}/common/teams`
export const FETCH_PLAYER_LEADERBOARD_URL = `${API_URL}/common/leaderboard/player/:playerId`

export const FETCH_PLAYER_POSITIONS_URL = `${API_URL}/web/players/positions`
